import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormularioInscripcionComponent } from './formulario-inscripcion/formulario-inscripcion.component';
import { ModalPagoComponent } from './modal-pago/modal-pago.component';
import { ExitoComponent } from './exito/exito.component';
import { ErrorComponent } from './error/error.component';

const routes: Routes = [
  { path: '', component: FormularioInscripcionComponent },
  { path: 'modal-pago', component: ModalPagoComponent },
  { path: 'exito/:token', component: ExitoComponent },
  { path: 'exito', redirectTo: '/exito/' },
  { path: 'error', component: ErrorComponent },
  { path: '**', redirectTo: '/error' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
